import React, { useEffect, useState } from 'react';
import styles from '../auth.module.css';
import checkStyle from '@/shared/ui/PrivacyAgreement/privacyAccepted.module.css'
import { Link, useNavigate } from 'react-router-dom';
import { getMe } from '@/entities/user/api/userApi.js';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import PhoneInput from '@/shared/ui/PhoneInput';
import PrivacyAgreement from "../../../shared/ui/PrivacyAgreement";
import {completeReg} from "../api";
import {useUser} from "@/entities/user/model/UserContext";

const CompleteReg = () => {
    const [name, setName] = useState('');
    const [gotName, setGotName] = useState(false);

    const [surname, setSurname] = useState('');
    const [gotSurname, setGotSurname] = useState(false);

    const [email, setEmail] = useState('');
    const [gotEmail,setGotEmail] = useState(false);

    const [birth, setBirth] = useState('');
    const [gotBirth, setGotBirth] = useState(false);

    const [phone, setPhone] = useState('');
    const [gotPhone, setGotPhone] = useState(false);

    const [friendPromo, setFriendPromo] = useState('');
    const [gotFriendPromo, setGotFriendPromo] = useState(false);

    const [playedLater, setPlayedLater] = useState(false);

    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isSubmitting,setIsSubmitting] = useState(false);

    const navigate = useNavigate();

    const { setUser } = useUser();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const access = params.get('access');
        const refresh = params.get('refresh');

        if (access && refresh) {
            localStorage.setItem('access_token', access);
            localStorage.setItem('refresh_token', refresh);
            localStorage.setItem('redirected_from_google', 'true');
            window.history.replaceState({}, document.title, '/auth/complete-reg');
            window.location.reload();
            return;
        }

        if (localStorage.getItem('redirected_from_google') === 'true') {
            localStorage.removeItem('redirected_from_google');
        }

        (async () => {
            try {
                const data = await getMe();
                if (data.phone) {
                    setPhone(data.phone);
                    setGotPhone(true);
                }
                if (data.name) {
                    setName(data.name);
                    setGotName(true);
                }
                if (data.surname) {
                    setSurname(data.surname);
                    setGotSurname(true);
                }
                if (data.dateOfBirth) {
                    setBirth(data.dateOfBirth);
                    setGotBirth(true);
                }
                if (data.email) {
                    setEmail(data.email);
                    setGotEmail(true);
                }
                if (data.registrationCompleted) {
                    setIsLoggedIn(true);
                    setLoading(false);
                    return;
                }

            } catch (e) {
                const errorMessage = e?.response?.data?.message || 'Ошибка при завершении регистрации';
                toast.error(errorMessage);
            }
            setLoading(false);
        })();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const formattedBirth = birth ? format(new Date(birth), 'yyyy-MM-dd') : null;

        try {
            const res = await completeReg( {
                name,
                surname,
                email,
                dateOfBirth: formattedBirth,
                phone,
                code: friendPromo,
                isPlayedBefore: playedLater
            });
            setUser(res.data)
            setSubmitted(true);
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'Ошибка при завершении регистрации';
            toast.error(errorMessage);
        }finally {
            setIsSubmitting(false);
        }
    };

    if (loading) {
        return (
            <section className={`${styles.authSection} container-custom`}>
                <p className="par1">Загрузка...</p>
            </section>
        );
    }

    if (submitted || isLoggedIn) {
        return navigate('/');
    }

    return (
        <section className={`${styles.authSection} container-custom`}>
            <img className={styles.logo} src="/images/logo%20new.svg" alt="Логотип ПОДЗЕМЕЛЬЕ" />
            <h1 className={`${styles.h1} par1`}>Регистрация</h1>

            <form className={styles.form} onSubmit={handleSubmit}>
                <input
                    type="text"
                    className="input"
                    placeholder="Имя"
                    value={name}
                    disabled={gotName}
                    onChange={(e) => setName(e.target.value)}
                />
                <input
                    type="text"
                    className="input"
                    placeholder="Фамилия"
                    value={surname}
                    disabled={gotSurname}
                    onChange={(e) => setSurname(e.target.value)}
                />
                <input
                    type="email"
                    className="input"
                    placeholder="Email"
                    value={email}
                    disabled={gotEmail}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <input
                    type="date"
                    className="input"
                    placeholder="Дата рождения"
                    value={birth}
                    disabled={gotBirth}
                    onChange={(e) => setBirth(e.target.value)}
                />

                <PhoneInput
                    value={phone}
                    disabled={gotPhone}
                    onChange={(formattedPhone) => {
                        setPhone(formattedPhone);
                    }}
                />

                <input
                    type="text"
                    className="input"
                    placeholder="Код друга"
                    value={friendPromo}
                    disabled={gotFriendPromo}
                    onChange={(e) => setFriendPromo(e.target.value)}
                />

                <label className={checkStyle.privacyPolicy}>
                    <input
                        type="checkbox"
                        checked={playedLater}
                        onChange={(e) => setPlayedLater(e.target.checked)}
                    />

                        Играли у нас раньше

                </label>

                <PrivacyAgreement
                    setPrivacyAccepted={setPrivacyAccepted}
                    privacyAccepted={privacyAccepted}
                />

                <button type="submit" className="btn btn-red-filled w-100" disabled={!privacyAccepted || isSubmitting}>
                    Зарегистрироваться
                </button>
            </form>
        </section>
    );
};

export default CompleteReg;
